<template>
  <div></div>
</template>
<script>
import Wechat from '@/api/utils';
export default {
  mounted() {
    // this.share()
    this.shareConfig()
  },
  data() {
    return {};
  },
  methods: {
    shareConfig() {
      let data = {
        url: window.location.href,
        share_id: ''
      };
      Wechat.shareConfig(data).then(res => {
        if (res.code === '1') {
          let { appId, timestamp, nonceStr, signature } = res.data;
          let query = { ...this.$route.query };
          if (wx) {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: appId, // 必填，公众号的唯一标识
              timestamp: timestamp, // 必填，生成签名的时间戳
              nonceStr: nonceStr, // 必填，生成签名的随机串
              signature: signature, // 必填，签名
              jsApiList: [
                'onMenuShareTimeline', // 分享到朋友圈
                'onMenuShareAppMessage', // 分享给朋友
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareQQ' //分享到QQ
              ] // 必填，需要使用的JS接口列表
            });
            wx.ready(() => {
              this.weChatShare()
            })
          }
        } else {
          // Toast.fail(res.data || '请求失败');
        }
      }).catch(e => {
          // Toast.fail(e);
      });
      if (wx) {
        wx.error(e => {
          //   Toast.fail('sdk出错啦，' + e.errMsg);
        });
      }
    },
      // 微信分享
    weChatShare: (info = {}) => {
      let jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline']
      wx.checkJsApi({
          jsApiList: jsApiList, // 需要检测的JS接口列表，所有JS接口列表见附录2,
          success: function (res) {
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          let shareType_1 = 'onMenuShareAppMessage'
          let shareType_2 = 'onMenuShareTimeline'
          // if (JSON.parse(res.checkResult).updateAppMessageShareData) {
          //   shareType_1 = 'updateAppMessageShareData'
          // }
          // if (JSON.parse(res.checkResult).updateTimelineShareData) {
          //   shareType_2 = 'updateTimelineShareData'
          // }
          // 分享给会话
          // jsApiList.forEach(ele => {
          //   wx[ele]({
          //     title: info.name || '集智学园-企业培训', // 分享标题
          //     desc: info.detail || '专注于人工智能和复杂系统，面向企业的定制化培训和咨询服务', // 分享描述
          //     link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          //     imgUrl: 'http://wiki.swarma.net/images/thumb/c/c0/%E5%AD%A6%E5%9B%AD%E6%97%A0%E8%83%8C%E6%99%AF.png/300px-%E5%AD%A6%E5%9B%AD%E6%97%A0%E8%83%8C%E6%99%AF.png' // 分享图标, // 分享图标
          //   })
          // })
          wx[shareType_1]({
            title: info.name || '集智学园-企业培训', // 分享标题
            desc: info.detail || '专注于人工智能和复杂系统，面向企业的定制化培训和咨询服务', // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'http://wiki.swarma.net/images/thumb/c/c0/%E5%AD%A6%E5%9B%AD%E6%97%A0%E8%83%8C%E6%99%AF.png/300px-%E5%AD%A6%E5%9B%AD%E6%97%A0%E8%83%8C%E6%99%AF.png' // 分享图标, // 分享图标
          })
          // 朋友圈/qq空间
          wx[shareType_2]({
            title: info.name || '集智学园-企业培训', // 分享标题
            desc: info.detail || '专注于人工智能和复杂系统，面向企业的定制化培训和咨询服务', // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'http://wiki.swarma.net/images/thumb/c/c0/%E5%AD%A6%E5%9B%AD%E6%97%A0%E8%83%8C%E6%99%AF.png/300px-%E5%AD%A6%E5%9B%AD%E6%97%A0%E8%83%8C%E6%99%AF.png' // 分享图标, // 分享图标
          })
          // alert(window.location.href)
        }
      })
    }
  }
};
</script>
